import { render } from "./AusenciasSuplenciasDocentesPage.vue?vue&type=template&id=6075122a"
import script from "./AusenciasSuplenciasDocentesPage.vue?vue&type=script&lang=js"
export * from "./AusenciasSuplenciasDocentesPage.vue?vue&type=script&lang=js"

import "./AusenciasSuplenciasDocentesPage.vue?vue&type=style&index=0&id=6075122a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__